@if (field && field.invalid && (field.dirty || field.touched)) {
  <div>
    @for (err of keys(messages); track err) {
      <div>
        @if (field.errors && field.errors[err]) {
          <div>
            <p-message severity="error" [text]="messages[err]" closable="false"></p-message>
          </div>
        }
      </div>
    }
  </div>
}
